// components/Layoutsecond.jsx
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import LeftSidebar from "./LeftSidebar";

export default function Layoutsecond({ children, rightSidebar }) {
  const location = useLocation();
  const isCategoryPage = location.pathname === "/category";
  const isDiscoverPage = location.pathname === "/discover";
  const isDiscoverDetailsPage = location.pathname.startsWith("/discover-details/");

  const hideRightSidebar = isCategoryPage || isDiscoverPage || isDiscoverDetailsPage;
  return (
    <>
      <Header />
      <main className="columnLayout">
        <div className="container">
          
            <LeftSidebar />

            <div className={`${hideRightSidebar  ? "mainContaint noRightSidebar" : "mainContaint"}`}>
              <div className="main-wrapper">{children}</div>
            </div>

            {/* Conditional Right Sidebar */}
            {!hideRightSidebar && (
             <div className="rightSidebar">{rightSidebar}</div>
            )} 
          </div>
      </main>
      {/* <Footer /> */}
    </>
  );
}
